import { Component } from 'react';

export default class Title extends Component {
  render() {
    switch(this.props.header) {
      case 'h1':
        return ( <h1 className="title--h1"><span>{this.props.title}</span></h1> )
      case 'h2':
        return ( <h2 className="title--h2"><span>{this.props.title}</span></h2> )
      case 'h3':
        return ( <h3 className="title--h3"><span>{this.props.title}</span></h3> )
      case 'h4':
        return ( <h4 className="title--h4"><span>{this.props.title}</span></h4> )
      case 'h5':
        return ( <h5 className="title--h5"><span>{this.props.title}</span></h5> )
      default:
        return
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/modules/Title.js
 **/